import { LABEL_COLORS } from '@/constants/LabelColors'

/**
 * Returns inline styles for a label chip using oklch color-mix
 * for accessible tinted backgrounds with the label's color as text.
 */
export function getLabelChipStyles(color: string) {
	return {
		backgroundColor: `color-mix(in oklch, ${color} 15%, transparent)`,
		color,
		borderColor: `color-mix(in oklch, ${color} 30%, transparent)`,
	}
}

/**
 * Returns the next available color from the preset palette.
 * Skips colors already in use, wraps around when all are taken.
 */
export function getNextLabelColor(existingColors: string[]): string {
	const unused = LABEL_COLORS.filter((c) => !existingColors.includes(c))
	return unused[0] ?? LABEL_COLORS[0]!
}
